import type { Day } from 'date-fns'
import { intervalToDuration, millisecondsToMinutes } from 'date-fns'
import { defaultOptions } from '../i18n/i18n'

export const prependZero = (val: unknown) =>
  `${val}`.length === 1 ? `0${val}` : val

const getDayOfWeek = (dow: number) =>
  (dow + (defaultOptions().locale.options?.weekStartsOn ?? 0)) % 7

export const getLocalisedWeekdays = (): string[] => {
  return [...Array(7).keys()].map(dow =>
    defaultOptions().locale?.localize?.day(getDayOfWeek(dow) as Day),
  )
}

type FormattedDuration = `${string}:${string}` // 04:19

export const formatToMinutes = (durationInMs: number): FormattedDuration => {
  const duration = intervalToDuration({
    start: 0,
    end: durationInMs,
  })

  // Before the first second (0ms to 999ms) seconds will be undefined
  return `${prependZero(millisecondsToMinutes(durationInMs))}:${prependZero(duration.seconds ?? 0)}`
}
